import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/reports/:id/title' }

type Params = { id: number }
type Body = never
type Query = never
type Output = { title: Nullable<string>; workflowName: string }

export type GetTitleEndpoint = Endpoint<Params, Body, Query, Output>

export const getTitleRequest = (request: Request, args: RequestArgs<GetTitleEndpoint>) =>
    request<GetTitleEndpoint>(route, args)
